import "./index.scss";
import "../../assets/scripts/WhirSwiper";

$(document).ready(function(){
  $('.headline .right .item-t').eq(0).show()
  $('.headline .left .left-date .date-item').eq(0).show()
  $('.headline .left .bottom-btn .right-btn .active-num').html('01')

  var total = '0' + $('.headline .left .whir-container .whir-slide').length
  $('.headline .left .bottom-btn .right-btn .total-num').html(total)
})

var companySwiper = new WhirSwiper('.headline .left .whir-container',{
  navigation:{
      prevEl:'.headline .left .whir-button-prev',
      nextEl:'.headline .left .whir-button-next',
  }
})

companySwiper.afterSlide = function(){
  var index = this.index
  $('.headline .right .item-t').eq(index).show().siblings().hide()
  $('.headline .left .left-date .date-item').eq(index).show().siblings().hide()
  $('.headline .left .bottom-btn .right-btn .active-num').html('0'+(index+1))
}